import { UserService } from '@app/services/user/user.service';
import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-sso-login',
	template: '',
})
export class SsoLoginComponent implements OnInit {
	constructor(private userService: UserService) {}

	public ngOnInit(): void {
		this.userService.requestLogin({
			isSSO: true,
			step: 'login',
		});
	}
}
